/**
 * The OS's reduce-motion preference, read once per mount (#1069 Story 7.6,
 * D11; moved verbatim from `CorrespondenceDock.tsx`, where it was written for
 * the open/close animation).
 *
 * ⚠️ OPTIONAL-CALLED, AND `false` BY DEFAULT (C9). `AccessibilityInfo` is
 * absent from the shared react-native mock in `src/setupTests.ts`, and the
 * API is absent on some platforms; animating is the safe default either way.
 * `CorrespondenceDock.test.tsx` installs the member on the mocked module for
 * ONE case and restores it -- do not add it to the shared mock for every
 * suite, and do not read it at module scope (a module-scope read is resolved
 * before any test's `beforeEach`, the Story 7.2 lesson).
 *
 * One hook rather than three copies of the same effect (the Dock, the list,
 * the row): two copies of "read `AccessibilityInfo` if it exists" is the drift
 * `.claude/rules/correspondence.md` warns about, and the Dock's existing pin
 * is the regression guard for the move.
 */
import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

export function useReduceMotion(): boolean {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    let alive = true;
    // Optional-called because the API is absent on some platforms; animating is
    // the safe default either way.
    AccessibilityInfo?.isReduceMotionEnabled?.()
      ?.then(v => {
        if (alive) setReduceMotion(v);
      })
      ?.catch(() => {
        // Unsupported on some platforms; animating is the safe default.
      });
    return () => {
      alive = false;
    };
  }, []);

  return reduceMotion;
}
